import { 
  useContext,
  useState, 
} from "react";

import { TenantContext } from "../../../templates/context/TenantContext";

import { i18n } from "../../../translate/i18n";

import { AccuracyTable } from "./components/accuracy.index";
import { Default } from "../../../components/Default/Default";

import { 
  Carousel,
  ProductAccuracyChart,
  SectionHeader,
  NewTableOptions,
  LoadingContent
} from "../../../components/SharedComponents/sharedComponents.index";
import { PageHeading } from "../../../components/StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';
import { LOADING_CONTENT_TYPE } from "../../../components/SharedComponents/LoadingContent/loading.content.constants";
import { useAnalysisViewModel } from "../../../viewModel/useAnalysysViewModel";

const { t } = i18n;

function AccuracyChartCarousel({ ctx }) {

  const { checkedProducts, products } = ctx || {}

  if(!checkedProducts) {
    return (
      <LoadingContent label={t("errorContactAdmin")} type={LOADING_CONTENT_TYPE.VIEW_DATA} mode={LOADING_CONTENT_TYPE.VIEW_DATA}/>
    )
  }

  return (
    <Carousel slideNumber={checkedProducts.length}>
      {checkedProducts.map((productId, index) => (
        <div className={`carousel-item ${index === 0 ? "active" : ""} justify-content-center`} key={productId}>
          <div className="w-75">
            <ProductAccuracyChart ctx={{ products: products, productId: productId }}/>
          </div>
        </div>
      ))}
    </Carousel>
  );
}

export function Accuracy() {

  const vm = useAnalysisViewModel({
    shouldFetchLastSixMonthsPredictions: true,
    shouldFetchProducts: true,
    shouldFetchFiltersAndDriversOptions: true,
    shouldFetchForecastData: true
  });

  const { hierarchy } = useContext(TenantContext);

  const [checkedProducts, setCheckedProducts] = useState([]);
  const [selectedHierarchyIndexes, setSelectedHierarchyIndexes] = useState(hierarchy.levels.map((level, index) => index));

  if (vm.uiState.isForecastLoading || vm.uiState.isLoadingProducts) {
    return (
      <LoadingContent label={t("recentPredictions")} type={LOADING_CONTENT_TYPE.API_PAGE_DATA} mode={LOADING_CONTENT_TYPE.API_PAGE_DATA}/>
    )
  }  

  return (
    <Default>
      <PageHeading>{t("analyzeProductAccuracy")}</PageHeading>
      <SectionHeader ctx={{ heading: t("productView"), subtitles: [`${t("lastForecastGeneratedOn")}: ${vm.ctx.generationDate}`] }}/>

      <NewTableOptions
        actions={{
          checkedProducts: checkedProducts,
          renderGraphicAnalysis: () => (
            <AccuracyChartCarousel ctx={{ products: vm?.ctx?.products, checkedProducts: checkedProducts }}  />
          ),
          setFreezeColumns: vm.actions.setFreezeColumns,
          setSelectedHierarchyIndexes: setSelectedHierarchyIndexes,
          setSelectedProductIds: vm.actions.setSelectedProductIds
        }}
        ctx={{
          selectedHierarchyIndexes: selectedHierarchyIndexes,
          productIds: vm.ctx.productIds,
          selectedProductIds: vm.ctx.selectedProductIds,
          products: vm?.ctx?.products
        }}        
        uiState={{
          freezeColumns: vm.uiState.freezeColumns,
          showSalesHystory: false,
          downdownloadButton: false,
          showFilterButton: true,
          showCustomHeading: false
        }}/>

      <AccuracyTable
        actions={{ setCheckedProducts: setCheckedProducts }}
        ctx={{
          checkedProducts: checkedProducts,
          selectedHierarchyIndexes: selectedHierarchyIndexes,
          selectedProductIds: vm.ctx.selectedProductIds,
          products: vm?.ctx?.products
        }}
        uiState={{ freezeColumns: vm.uiState.freezeColumns }}
        />
    </Default>
  );
};

AccuracyChartCarousel.propTypes = {
  ctx: PropTypes.shape()
}